<template>
	<div class="app-container">
		<div class="head-container">
			<!-- 搜索区域 -->
			<ProblemProcessSearchform @searchForm="searchFormHandler"></ProblemProcessSearchform>
			<div>
				<!-- 功能按钮 -->
				<Button
					@showDialogAdd="showDialogAddHandler"
					@showDialogEdit="showDialogEditHandler"
					@showDelete="showDeleteHandler"
					:selectData_p="selectData"
					:delTips_p="delTips"
					:editDisabled_p="editDisabled"
					:authorize_p="'process'"
					:isHide_p="{ removeBtn: true, updateBtn: true }"
				></Button>
			</div>
		</div>
		<!--表格渲染-->
		<Table ref="tableDom" :data.sync="tableData" :tableColumn_p="tableColumn" :selectData_p.sync="selectData" :isHideCheckbox_p="true">
			<el-table-column label="ID" prop="id"></el-table-column>
			<el-table-column label="处理方式" prop="name"></el-table-column>
			<el-table-column label="操作" align="left" fixed="right" width="300">
				<template slot-scope="scope">
					<el-button
						id="btn-update-row"
						type="primary"
						@click="editSingleHandler(scope.row)"
						v-authorize="{ name: 'update', type: 'process', id: 'btn-update-row' }"
					>
						编辑
					</el-button>
					<el-button
						id="btn-remove-row"
						type="danger"
						@click="deleteSingleHandler(scope.row)"
						v-authorize="{ name: 'remove', type: 'process', id: 'btn-remove-row' }"
					>
						删除
					</el-button>
				</template>
			</el-table-column>
		</Table>
		<Pagination :total="total" :pageIndex_p.sync="pageIndex" :pageSize_p.sync="pageSize"></Pagination>
		<Dialog :title="dialogTitle" :visible.sync="isShowAEDialog">
			<ProblemProcessAddForm
				v-if="isShowAEDialog"
				:isShowAEDialog_p.sync="isShowAEDialog"
				:isRefreshList_p.sync="isRefreshList"
				:selectData_p="selectData"
				:editId_p="editId"
			></ProblemProcessAddForm>
		</Dialog>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { deleteService, listService, detailService } from '@s/base/ProblemProcessService.js';

import ProblemProcessAddForm from '@f/base/ProblemProcess/ProblemProcessAdd.form';
import ProblemProcessSearchform from '@f/base/ProblemProcess/ProblemProcessSearch.form';

import Button from '@c/ui/Button';
import Table from '@c/ui/Table';
import Pagination from '@c/ui/Pagination';
import Dialog from '@c/ui/Dialog';
import ListMixin from '@m/List.mixin';

export default {
	mixins: [ListMixin],
	components: {
		Button,
		Table,
		Pagination,
		Dialog,
		ProblemProcessSearchform,
		ProblemProcessAddForm
	},
	data() {
		return {
			// 表格
			tableColumn: [],
			delTips: '',
			isShowConfigDialog: false,
			editDisabled: true
		};
	},
	computed: {
		dialogTitle() {
			return this.editId === -1 ? '新增处理方式' : '编辑处理方式';
		}
	},
	watch: {
		pageIndex(newValue) {
			this.pageIndex = newValue;
			this.getList();
		},
		pageSize(newValue) {
			this.pageSize = newValue;
			this.getList();
		},
		isRefreshList(newValue) {
			if (newValue) {
				this.getList();
			}
		}
	},
	mounted() {
		this.getList();
	},
	methods: {
		async getList() {
			const dataJson = {
				pageNum: this.pageIndex,
				pageSize: this.pageSize,
				name: '',
				...this.searchForm
			};
			const res = await listService(dataJson);
			console.log(res);
			this.listMixin(res);
			// this.tableData = [
			// 	{
			// 		id: 1,
			// 		name: '序号1'
			// 	},
			// 	{
			// 		id: 2,
			// 		name: '序号2'
			// 	}
			// ];
		},
		showDialogAddHandler() {
			this.dialogAddHandlerMixin();
		},
		async showDialogEditHandler() {
			const editId = this.dialogEditHandlerMixin();
			const dataJson = {
				id: editId
			};
			const res = await detailService(dataJson);
			this.selectData = [res];
			this.isShowAEDialog = true;
		},
		async showDeleteHandler() {
			const ids = this.filterSelectIdsMixin();
			const dataJson = ids;
			await deleteService(dataJson);
			this.isRefreshList = true;
		},
		async editSingleHandler(row) {
			const dataJson = {
				id: row.id
			};
			const res = await detailService(dataJson);
			this.editSingleHandlerMixin(res);
		},
		deleteSingleHandler(row) {
			this.deleteSingleHandlerMixin(row);
		},
		searchFormHandler(searchForm) {
			this.searchFormHandlerMixin(searchForm);
			this.getList();
		}
	}
};
</script>

<style lang="less" scoped>
.orglist {
	height: 400px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
